<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useMessageContext } from '../../provider.js';

const { additionalAttributes } = useMessageContext();

const rating = computed(() => additionalAttributes.value?.rating ?? null);
</script>

<template>
  <span v-if="rating === 'up'" class="inline-flex items-center text-n-teal-11">
    <Icon icon="i-lucide-thumbs-up" class="size-3" />
  </span>
  <span
    v-else-if="rating === 'down'"
    class="inline-flex items-center text-n-ruby-11"
  >
    <Icon icon="i-lucide-thumbs-down" class="size-3" />
  </span>
</template>
